var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoodCoverLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3022 17.3109V14.6482V17.3109Z",
    fill: "#8958A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3022 17.3109V14.6482",
    stroke: "#8958A3",
    strokeWidth: 1.33139,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6073 35.9504C40.6073 25.2885 31.9641 16.6453 21.3022 16.6453C10.6403 16.6453 1.99707 25.2885 1.99707 35.9504H40.6073Z",
    fill: "#41197F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3022 19.9737C15.0367 19.9737 9.6135 23.5804 6.99561 28.8309",
    stroke: "white",
    strokeWidth: 1.33139,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9402 35.9504H1.66423C0.745103 35.9504 0 36.6955 0 37.6146C0 38.5337 0.745103 39.2788 1.66423 39.2788H40.9402C41.8593 39.2788 42.6044 38.5337 42.6044 37.6146C42.6044 36.6955 41.8593 35.9504 40.9402 35.9504Z",
    fill: "#8958A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6395 13.3168H23.965V15.3139H18.6395V13.3168Z",
    fill: "#41197F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3205 0C27.7159 0 25.6044 1.57238 25.6044 4.76379C25.6044 7.95521 32.7248 15.1321 33.927 15.1321C35.1292 15.1321 42.2496 7.95521 42.2496 4.76379C42.2496 1.57238 40.1381 0 37.5335 0C36.0867 0 34.7921 0.658024 33.927 1.69394C33.0619 0.658024 31.7673 0 30.3205 0Z",
    fill: "#E44343"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7189 2.27313C29.014 2.27313 27.3092 3.97798 28.4458 6.2511",
    stroke: "white",
    strokeWidth: 1.51321,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodCoverLogo);
export default __webpack_public_path__ + "static/media/foodCoverLogo.0b8d0c20f8838da53b7f8b47446aaed7.svg";
export { ForwardRef as ReactComponent };